import React from "react";

const TargetingApp = ({
  height = 30,
  width = 30,
  className = "",
  color = "#FFF",
  viewBox = "-1 -2 35 35",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    {...rest}
  >
    <rect y="2.95" width={width} height={height} fill="none" />
    <path
      d="M42.78,44.1H46.5v3.1H37.19V37.88h3.1v4.24a12.39,12.39,0,0,0-6.21-22V17a15.52,15.52,0,0,1,8.7,27.1ZM20.11,32.45a12.33,12.33,0,0,1,4.65-9.67V27h3.11V17.7H18.55v3.1h3.73A15.52,15.52,0,0,0,31,47.9V44.76A12.42,12.42,0,0,1,20.11,32.45Z"
      transform="translate(-16 -17)"
      fill={color}
    />
    <polyline
      points="10.5 15.4 13.79 19.01 23 10.24"
      fill="none"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export default TargetingApp;
